import { Component, Vue } from "vue-property-decorator";
import { menuBtn } from '@/utils/menu_level2_button'
import { UserModule } from '@/store/modules/user'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceOrderRecordList, financeOrderRecordExportData } from '@/api/financial-center'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class OrderRecord extends Vue {
    page = 1
    total = 0
    limit = 20
    tableHeadPopoverShow = false

    tableHeader = [
        { filds: 'financeOrderCode', cnFilds: '订单编号', isShow: true, id: 1 },
        { filds: 'customerName', cnFilds: '客户名称', isShow: true, id: 2 },
        { filds: 'customerType', cnFilds: '客户类型', isShow: true, id: 3 },
        { filds: 'directorUserRealName', cnFilds: '负责人', isShow: true, id: 4 },
        { filds: 'types', cnFilds: '变更类型', isShow: true, id: 5 },
        { filds: 'prevSouCourseName', cnFilds: '变更前项目', isShow: true, id: 6 },
        { filds: 'prevSouCourseSchoolBegin', cnFilds: '变更前开课时间', isShow: true, id: 7 },
        { filds: 'endSouCourseName', cnFilds: '变更后项目', isShow: true, id: 8 },
        { filds: 'endSouCourseSchoolBegin', cnFilds: '变更后开课时间', isShow: true, id: 9 },
        { filds: 'submitAt', cnFilds: '提交时间', isShow: true, id: 10 },
        { filds: 'approvedAt', cnFilds: '通过时间', isShow: true, id: 11 },
    ]
    tableData = []
    tableLoading = false
    tableKey = Math.random()

    filter_costomerName = ''
    filter_costomerType = ''
    filter_userIdList: string[] = []
    filter_types = ''
    filter_prevName = ''
    filter_prevBegin = []
    prevBegin = ''
    filter_endName = ''
    filter_endBegin = []
    endBegin = ''
    submitAt = ''
    filter_submitAt = []
    approvedAt = ''
    filter_approvedAt = []
    costomerTypeList: [
        {}
    ]
    exportButtonDisabled = false
    exportHeaderDialogVisible = false


    menuBtn = menuBtn
    created() {
        this.getTableData()
    }
    async getTableData() {
        this.tableLoading = true
        const obj = {
            customerName: this.filter_costomerName,
            customerType: this.filter_costomerType,
            directorUserIdList: this.filter_userIdList,
            types: this.filter_types,
            prevSouCourseName: this.filter_prevName,
            endSouCourseName: this.filter_endName,
            prevSouCourseSchoolBegin: this.prevBegin,
            endSouCourseSchoolBegin: this.endBegin,
            submitAt: this.submitAt,
            approvedAt: this.approvedAt,
            limit: this.limit,
            page: this.page,
        }
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        const data: any = await getFinanceOrderRecordList(obj)
        this.tableData = data.financeOrderRecordList
        this.total = data.allNum
        this.tableLoading = false
        this.tableKey = Math.random()
    }
    prevTimeChange() {
        if(this.filter_prevBegin == null){
            this.prevBegin = ''
        }else {
            this.prevBegin = formatDate('yyyy-MM-dd', new Date(this.filter_prevBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_prevBegin[1]))
        }
        this.page = 1
        this.getTableData()
    }
    endTimeChange() {
        if(this.filter_endBegin == null){
            this.endBegin = ''
        }else{
            this.endBegin = formatDate('yyyy-MM-dd', new Date(this.filter_endBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_endBegin[1]))
        }
        this.page = 1
        this.getTableData()
    }
    submitAtChange(){
        if(this.filter_submitAt == null){
            this.submitAt = ''
        }else{
            this.submitAt = formatDate('yyyy-MM-dd', new Date(this.filter_submitAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_submitAt[1]))
        }
        this.page =1
        this.getTableData()
    }
    approvedAtChange(){
        if(this.filter_approvedAt == null){
            this.approvedAt = ''
        }else{
            this.approvedAt = formatDate('yyyy-MM-dd', new Date(this.filter_approvedAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_approvedAt[1]))
        }
        this.page = 1
        this.getTableData()
    }
    draggableEnd() {
        this.tableHeadPopoverShow = false
        // TODO 修改表头
    }
    async exportData(keys: string = '') {
        this.exportButtonDisabled = true
        const obj = {
            customerName: this.filter_costomerName,
            customerType: this.filter_costomerType,
            directorUserIdList: this.filter_userIdList,
            types: this.filter_types,
            prevSouCourseName: this.filter_prevName,
            endSouCourseName: this.filter_endName,
            prevSouCourseSchoolBegin: this.prevBegin,
            endSouCourseSchoolBegin: this.endBegin,
            submitAt: this.submitAt,
            approvedAt: this.approvedAt,
            keys,
        }
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        financeOrderRecordExportData(obj)
            .then(()=>{
                this.$message.success('数据已转入后台导出, 请前往下载列表查看')
            })
            .finally(() => [
            this.exportButtonDisabled = false
        ])
    }

    pageChange(page: number) {
        this.page = page
        this.getTableData()
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    changeFilterUserIdList(e) {
        this.filter_userIdList = e.id
        this.pageChange(1)
    }
}